import { useEffect } from "react";
import { message } from "antd";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { fetchUserProfile } from "../../store/authSlice";

/**
 * Polls the backend while logged in so a session revoked elsewhere (e.g. a
 * newer login on another browser — single-session enforcement lives in
 * epaper-session.js on the backend) is noticed within this interval instead
 * of only on the next navigation. `ProtectedRoute` only re-validates when
 * `user` isn't loaded yet, so without this an already-loaded tab would keep
 * showing "logged in" indefinitely after being kicked.
 */
const POLL_INTERVAL_MS = 30 * 1000;

const SessionWatcher = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, token } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated || !token) return;

    const interval = setInterval(async () => {
      const result = await dispatch(fetchUserProfile(token));
      if (fetchUserProfile.rejected.match(result)) {
        message.warning(
          typeof result.payload === "string"
            ? result.payload
            : "You have been signed out. Please log in again."
        );
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isAuthenticated, token, dispatch]);

  return null;
};

export default SessionWatcher;
